import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // 빌드/런타임 진단을 쉽게 하기 위해 콘솔 경고만 남기고 throw하지는 않는다.
  // 환경 변수 미설정 시 supabase 호출에서 자연스럽게 에러가 나도록 둔다.
  // eslint-disable-next-line no-console
  console.warn(
    '[supabase] REACT_APP_SUPABASE_URL 또는 REACT_APP_SUPABASE_ANON_KEY 가 설정되어 있지 않습니다.'
  );
}

export const supabase = createClient(url ?? '', anonKey ?? '');

export type LifeItem = {
  id: string;
  text: string;
  checked: boolean;
  position: number;
  group_id: string | null;
  created_at: string;
  updated_at: string;
};

export type TodoGroup = {
  id: string;
  title: string;
  position: number;
  created_at: string;
  updated_at: string;
};

export type DailyEntry = {
  id: string;
  entry_date: string; // YYYY-MM-DD
  content: string;
  rating: number; // 1~6
  position: number;
  created_at: string;
  updated_at: string;
};
